import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,

      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      content: "",
      newsType: 0,
      orderNumber: 0,

      /* --------------------------------------- */
      id: "",
      ids: [],
      noDataShow: false,
      value: "",
      StartTime: "",
      EndTime: "",
      LinkUrl: ""
    };
  },
  created: function created() {
    this.school = this.$store.state.auth.userName;
    this.getSpecialList(1);
  },
  methods: {
    getSpecialList: function getSpecialList(page) {
      var _this = this;

      var that = this;
      this.$http.post("/api/XOrg/SpecialActivity/getSpecialList", {
        title: this.sTitle,
        type: 3,
        page: page,
        pageSize: this.pageSize
      }).then(function (rst) {
        if (rst.code == 1) {
          _this.list = rst.list;
          _this.total = rst.pagination.totalCount;
          _this.pageSize = rst.pagination.pageSize;
          _this.pageIndex = rst.pagination.pageIndex;

          _this.cancel();
        } else {
          _this.$message.warning(rst.msg);
        }
      });
    },
    onPageChangeHandler: function onPageChangeHandler(page) {
      this.getSpecialList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getSpecialList(1);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.ids = [];
      val.forEach(function (element) {
        _this2.ids.push(element.Id);
      });
    },
    cancel: function cancel() {
      this.addNewNoticeVisible = false, this.editNoticeVisible = false, this.title = "", this.content = "", this.StartTime = "";
      this.EndTime = "";
      this.newsType = 0;
    },
    // 开始活动
    startSpecial: function startSpecial(id) {
      var that = this;
      this.$http.post("/api/XOrg/SpecialActivity/startSpecial", {
        specialId: id
      }).then(function (rst) {
        if (rst.code === 1) {
          that.$message.success(rst.msg);
          that.getSpecialList();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    endSpecial: function endSpecial(id) {
      var that = this;
      this.$http.post("/api/XOrg/SpecialActivity/endSpecial", {
        specialId: id
      }).then(function (rst) {
        if (rst.code === 1) {
          that.$message.success(rst.msg);
          that.getSpecialList();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    addSpecial: function addSpecial() {
      var that = this;
      this.$http.post("/api/XOrg/SpecialActivity/addSpecial", {
        Title: that.title,
        Content: that.content,
        type: 3,
        StartTime: that.StartTime,
        EndTime: that.EndTime,
        LinkUrl: that.LinkUrl
      }).then(function (rst) {
        if (rst.code === 1) {
          that.cancel();
          that.$message({
            showClose: true,
            message: rst.msg,
            type: "success"
          });
          that.getSpecialList();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    editSpecial: function editSpecial() {
      var that = this;
      this.$http.post("/api/XOrg/SpecialActivity/editSpecial", {
        id: that.schoolnewsId,
        title: that.title,
        content: that.content,
        startTime: that.StartTime,
        endTime: that.EndTime,
        linkUrl: that.LinkUrl
      }).then(function (rst) {
        if (rst.code === 1) {
          that.cancel();
          that.$message({
            message: rst.msg,
            type: "success"
          });
          that.editNoticeVisible = false;
          that.getSpecialList();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    add: function add() {
      this.addNewNoticeVisible = true;
    },
    edit: function edit(row) {
      this.editNoticeVisible = true;
      this.title = row.title;
      this.content = row.content;
      this.StartTime = row.startTime;
      this.EndTime = row.endTime;
      this.LinkUrl = row.linkUrl;
      this.schoolnewsId = row.id;
      this.newsType = row.type;
    },
    deleteMajor: function deleteMajor(id) {
      var _this3 = this;

      var that = this;
      this.$confirm("此操作将删除该考核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this3.$http.post("/api/XOrg/SpecialActivity/deleteSpecial", {
          id: id
        }).then(function (rst) {
          if (rst.code === 1) {
            that.$message({
              message: rst.msg,
              type: "success"
            });
            that.getSpecialList(1);
          }
        });
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    search: function search() {
      this.getSpecialList(1);
    },
    gOView: function gOView(id) {
      this.$router.push({
        name: "PeiXunEnrollManager",
        params: {
          activityId: id
        }
      });
    }
  }
};